<ng-container *cftI18n="let t">
  <div class="flex justify-start rounded-3" [ngClass]="{'bg-white p-lg shadow-1 md:py-xl md:shadow-3': !transparent}">
    @if (offering.icon) {
      <div class="text-xl md:text-3xl">
        <cft-dynamic-icon [icon]="offering.icon"></cft-dynamic-icon>
      </div>
    }
    <div class="w-full" [class.ml-lg]="offering.icon">
      <div class="text-sm font-semibold md:text-md">{{ offering.label }}</div>
      <div class="mt-xs flex justify-between">
        <div class="text-xs md:text-base">
          {{ priceLabel }}
        </div>
        <cft-minimum-price [minimumPrice]="minimumPrice"></cft-minimum-price>
      </div>
      @if (infoLabel) {
        <div class="mt-xs flex">
          <fa-icon [icon]="infoIcon"></fa-icon>
          <div class="ml-xs text-xs md:text-sm">
            {{ infoLabel }}
          </div>
        </div>
      }
    </div>
  </div>
</ng-container>
